<template>
  <div class="friend-request-icon">
    <span class="icon iconfont icon-bell" style="font-size: 28px"></span>
    <div v-if="unreadCount > 0" class="unread-badge">{{ formattedCount }}</div>
  </div>
</template>

<script>
import { getUnreadCount } from '@/api/friendRequest';

export default {
  name: 'FriendRequestIcon',
  data() {
    return {
      unreadCount: 0,
      timer: null
    };
  },
  computed: {
    formattedCount() {
      return this.unreadCount > 99 ? '99+' : this.unreadCount;
    }
  },
  created() {
    this.startPolling();
    // 监听好友请求已读事件
    this.$eventBus.$on('friendRequestRead', this.fetchUnreadCount);
  },
  beforeDestroy() {
    this.stopPolling();
    // 移除事件监听
    this.$eventBus.$off('friendRequestRead', this.fetchUnreadCount);
  },
  methods: {
    startPolling() {
      this.fetchUnreadCount();
      // 每30秒轮询一次
      this.timer = setInterval(this.fetchUnreadCount, 30000);
    },
    stopPolling() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    fetchUnreadCount() {
      getUnreadCount()
        .then(response => {
          this.unreadCount = response || 0;
        })
        .catch(() => {
          // 静默失败
          this.unreadCount = 0;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.friend-request-icon {
  position: relative;
  display: inline-block;
  color: var(--im-color-primary-light-4);
  
  .icon {
    font-size: 28px;
  }
  
  .unread-badge {
    position: absolute;
    background-color: var(--im-color-danger);
    left: 28px;
    top: 8px;
    color: white;
    border-radius: 30px;
    padding: 0 5px;
    font-size: var(--im-font-size-smaller);
    text-align: center;
    white-space: nowrap;
    border: 1px solid #f1e5e5;
    min-width: 16px;
    height: auto;
    line-height: normal;
  }
}
</style> 